/* Lithos - blog. Barre de progression, sommaire actif, FAQ, actions. Aucune dependance. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lithos-article]');
  if (!root) return;

  /* --- page guide : on reprend les sections du constructeur dans la colonne centrale ---
     La section hero reste au-dessus. Tout ce qui suit l'habillage descend dans le corps,
     ce qui donne a une page du constructeur la mise en page d'un article. */
  var guideBody = root.querySelector('[data-lb-guide-body]');
  if (guideBody && guideBody.hasAttribute('data-lb-rempli')) {
    /* le theme sert deja le contenu : seule la mention de prudence rejoint la colonne */
    var m0 = root.querySelector('.lb-guide-disclaimer');
    if (m0) guideBody.appendChild(m0);
    guideBody = null;
  }
  if (guideBody) {
    var hote = root.closest('.shopify-section') || root;
    var frere = hote.nextElementSibling;
    while (frere) {
      var suivant = frere.nextElementSibling;
      if (frere.tagName === 'SCRIPT' || frere.tagName === 'STYLE') { frere = suivant; continue; }
      guideBody.appendChild(frere);
      frere = suivant;
    }
    /* la mention de prudence appartient au fil de lecture, pas a la pleine largeur */
    var mention = root.querySelector('.lb-guide-disclaimer');
    if (mention) guideBody.appendChild(mention);
  }

  /* si la page porte deja un H1 dans son contenu, le notre fait doublon */
  var h1Pose = root.querySelector('[data-lb-h1]');
  if (h1Pose && document.querySelectorAll('h1').length > 1) h1Pose.remove();

  var body = root.querySelector('.lb-body');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- barre de progression --- */
  /* Le theme de la boutique masque les div vides : la barre porte un enfant. */
  var bar = document.createElement('div');
  bar.className = 'lb-progress';
  bar.setAttribute('role', 'presentation');
  var fill = document.createElement('i');
  bar.appendChild(fill);
  document.body.appendChild(bar);
  function progress() {
    if (!body) return;
    var r = body.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    var done = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
    fill.style.width = (done * 100).toFixed(2) + '%';
  }

  /* --- partage : copie du lien --- */
  var copier = root.querySelector('[data-lb-copier]');
  if (copier) {
    copier.addEventListener('click', function () {
      var url = copier.dataset.url || window.location.href;
      var fini = function () {
        var avant = copier.textContent;
        copier.textContent = 'Lien copié';
        setTimeout(function () { copier.textContent = avant; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(fini, function () {});
      } else {
        var z = document.createElement('textarea');
        z.value = url; document.body.appendChild(z); z.select();
        try { document.execCommand('copy'); fini(); } catch (e) {}
        document.body.removeChild(z);
      }
    });
  }

  /* --- FAQ : transforme le balisage de la fabrique de contenus en accordeon --- */
  var faqHost = root.querySelector('[data-lb-faq]');
  if (faqHost) {
    var items = faqHost.querySelectorAll('.faq-item');
    Array.prototype.forEach.call(items, function (item) {
      if (item.dataset.lbDone) return;
      var q = item.querySelector('h3, h4, strong, .faq-question');
      var a = item.querySelector('.faq-answer');
      if (!q || !a) return;
      var d = document.createElement('details');
      var s = document.createElement('summary');
      s.textContent = q.textContent.trim();
      var c = document.createElement('div');
      c.className = 'lb-faq-a';
      while (a.firstChild) c.appendChild(a.firstChild);
      d.appendChild(s); d.appendChild(c);
      item.parentNode.replaceChild(d, item);
      d.dataset.lbDone = '1';
    });
  }

  /* --- sommaire --- */
  function slug(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }
  var tocHost = root.querySelector('[data-lb-toc]');
  var links = [];
  var heads = [];
  if (tocHost && body) {
    heads = Array.prototype.slice.call(body.querySelectorAll('h2, h3'))
      .filter(function (h) {
        if (h.textContent.trim().length < 2) return false;
        if (h.closest('details, summary, .faq-item, .lb-faq')) return false;
        return true;
      });
    /* Le sommaire ne liste que les titres de premier niveau. Avec les h3 il
       vire a la liste de courses : les pages guides comptent 50 a 70 titres. */
    var seulsH2 = heads.filter(function (h) { return h.tagName === 'H2'; });
    if (seulsH2.length >= 2) heads = seulsH2;

    if (heads.length >= 3) {
      var used = {};
      var ol = document.createElement('ol');
      heads.forEach(function (h) {
        var id = h.id || slug(h.textContent);
        if (used[id]) { id = id + '-' + (used[id] += 1); } else { used[id] = 1; }
        h.id = id;
        var li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'lb-toc-sub';
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
        links.push(a);
      });
      tocHost.appendChild(ol);
      tocHost.hidden = false;
    } else {
      var wrap = tocHost.closest('[data-lb-toc-wrap]');
      if (wrap) wrap.remove();
    }
  }
  function spy() {
    if (!links.length) return;
    var best = 0;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].getBoundingClientRect().top <= 120) best = i; else break;
    }
    links.forEach(function (a, i) { a.classList.toggle('is-active', i === best); });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { progress(); spy(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  /* --- actions : copier le lien, resumer avec une IA --- */
  var copyBtn = root.querySelector('[data-lb-copy]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(window.location.href).then(function () {
        var old = copyBtn.querySelector('span').textContent;
        copyBtn.querySelector('span').textContent = 'Lien copié';
        setTimeout(function () { copyBtn.querySelector('span').textContent = old; }, 2000);
      });
    });
  }

  /* --- ancres douces --- */
  if (!reduce) {
    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href'));
    });
  }
})();

/* ============================================================
   Selection produits contextuelle au fil de l article.
   Le corps de l article porte seulement :
     <div class="lb-sel" data-lb-sel data-handles="a,b,c"
          data-kicker="..." data-title="..." data-intro="..."
          data-why="r1|r2|r3" data-badges="b1|b2|b3">
       <p class="lb-sel__fb">A decouvrir : <a href="/products/a">Nom</a>.</p>
     </div>
   Le repli en liens textuels reste dans le HTML : il porte le
   maillage interne et s affiche si le script ne repond pas.
   ============================================================ */
(function () {
  var blocks = document.querySelectorAll('[data-lb-sel]');
  if (!blocks.length) return;

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function split(v) {
    return (v || '').split('|').map(function (s) { return s.trim(); });
  }

  function card(p, why, badge, n) {
    var a = el('a', 'lb-sel__c');
    a.href = p.url;

    var im = el('span', 'lb-sel__im');
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = sized(p.featured_image, n === 1 ? 640 : 520);
      img.alt = p.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.width = 520;
      img.height = 520;
      im.appendChild(img);
    }
    if (badge) im.appendChild(el('span', 'lb-sel__badge', badge));
    if (im.firstChild) a.appendChild(im);

    var bd = el('span', 'lb-sel__bd');
    bd.appendChild(el('span', 'lb-sel__n', p.title));
    if (why) bd.appendChild(el('span', 'lb-sel__why', why));

    var ft = el('span', 'lb-sel__ft');
    if (p.available) {
      ft.appendChild(el('span', 'lb-sel__px', euro.format(p.price / 100)));
    } else {
      ft.appendChild(el('span', 'lb-sel__sold', 'Momentanément épuisé'));
    }
    ft.appendChild(el('span', 'lb-sel__go', 'Découvrir →'));
    bd.appendChild(ft);
    a.appendChild(bd);
    return a;
  }

  var first = true;

  Array.prototype.forEach.call(blocks, function (box) {
    var handles = (box.getAttribute('data-handles') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!handles.length) return;

    var whys = split(box.getAttribute('data-why'));
    var badges = split(box.getAttribute('data-badges'));
    var withTrust = first; first = false;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var ok = [];
      list.forEach(function (p, i) { if (p && p.url) ok.push({ p: p, i: i }); });
      if (!ok.length) return;              /* le repli textuel reste en place */

      var n = ok.length;
      var inner = el('div', 'lb-sel__in');

      var k = box.getAttribute('data-kicker');
      var t = box.getAttribute('data-title');
      var intro = box.getAttribute('data-intro');
      if (k || t || intro) {
        var hd = el('div', 'lb-sel__hd');
        if (k) hd.appendChild(el('span', 'lb-sel__k', k));
        if (t) hd.appendChild(el('p', 'lb-sel__t', t));
        if (intro) hd.appendChild(el('p', 'lb-sel__p', intro));
        inner.appendChild(hd);
      }

      var g = el('div', 'lb-sel__g');
      g.setAttribute('data-n', String(n));
      ok.forEach(function (o) { g.appendChild(card(o.p, whys[o.i], badges[o.i], n)); });
      inner.appendChild(g);

      if (withTrust) {
        var ul = el('ul', 'lb-sel__re');
        ['Assemblés en France', 'Expédition sous 24 à 48 h',
          'Retours 30 jours', 'Livraison offerte dès 40 €'
        ].forEach(function (s) { ul.appendChild(el('li', null, s)); });
        inner.appendChild(ul);
      }

      box.insertBefore(inner, box.firstChild);
      box.setAttribute('data-lb-sel-done', '');
    });
  });
}());

/* --- index du blog : themes encore sans article ---------------------------
   Shopify renvoie une 404 sur /tagged/<tag> tant qu'aucun article ne porte la
   balise. Ces themes pointent donc vers l'index avec ?theme=<slug> : on marque
   la puce active, on masque la grille et on affiche l'etat vide. */
(function () {
  var theme = new URLSearchParams(window.location.search).get('theme');
  if (!theme) return;
  var puce = document.querySelector('.lb-filter[data-lb-theme="' + theme + '"]');
  if (!puce) return;
  document.querySelectorAll('.lb-filter[aria-current]').forEach(function (a) {
    a.removeAttribute('aria-current');
  });
  puce.setAttribute('aria-current', 'true');
  var vide = document.querySelector('[data-lb-vide-theme]');
  if (vide) vide.hidden = false;
  ['.lb-featured', '.lb-grid-cards', '.lb-cards', '.lb-index-grid', '.lb-pagination']
    .forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { n.hidden = true; });
    });
})();
